import { FC, Fragment } from "react"

const App: FC = () => (
  <Fragment>
    <style>
      {`
    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.4); }
    }
  `}
    </style>
    <div
      style={{
        alignItems: "center",
        display: "flex",
        height: "100vh",
        justifyContent: "center",
      }}
    >
      <main
        style={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 12px 40px rgba(40, 65, 90, 0.10)",
          padding: "48px 36px",
          textAlign: "center",
          width: "min(90%, 560px)",
        }}
      >
        <div
          style={{
            alignItems: "center",
            animation: "pulse 2s ease-in-out infinite",
            background: "#eef6ff",
            borderRadius: "50%",
            color: "#3278c8",
            display: "flex",
            fontSize: "30px",
            height: "64px",
            justifyContent: "center",
            margin: "0 auto 22px",
            width: "64px",
          }}
          aria-hidden="true"
        >
          ⚙
        </div>
        <h1
          style={{
            color: "#26384a",
            fontSize: "32px",
            fontWeight: 700,
            letterSpacing: "0.04em",
            margin: "0 0 18px",
          }}
        >
          メンテナンス
        </h1>
        <div
          style={{
            background: "#3278c8",
            borderRadius: "999px",
            height: "3px",
            margin: "0 auto 24px",
            width: "44px",
          }}
        ></div>
        <p
          style={{
            color: "#5d6b78",
            fontSize: "16px",
            lineHeight: 1.9,
            margin: 0,
          }}
        >
          ただいまメンテナンス中です。再開までしばらくお待ちください。
        </p>
      </main>
    </div>
  </Fragment>
)

export default App
